import React from 'react';
import ResourceCard from './ResourceCard';

const GlobalResources = ({ resources, regionName }) => {
  if (!resources || resources.length === 0) {
    return null;
  }

  return (
    <div className="border-2 border-gray-300 bg-white rounded-xl shadow-lg p-6 mb-6">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <img 
          src="/aws-icons/AWS-Logo/AWS.svg" 
          alt="AWS"
          className="w-8 h-8"
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
        <h3 className="font-bold text-xl text-gray-900">Global Resources</h3>
        {regionName && (
          <span className="text-sm text-gray-500">
            (Region-independent or cross-region)
          </span>
        )}
        <span className="ml-auto px-3 py-1 bg-purple-100 text-purple-800 text-sm font-medium rounded-full">
          {resources.length} Resource{resources.length !== 1 ? 's' : ''}
        </span>
      </div>
      
      {/* Resources Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {resources.map((resource, idx) => (
          <ResourceCard key={`global-${resource.id}-${idx}`} resource={resource} />
        ))}
      </div>
    </div>
  );
};

export default GlobalResources;
